import * as React from 'react'
import { Avatar } from '@/shared/ui'

export type PostCardAuthorMetaProps = {
  name: string
  avatarUrl?: string | null
  dateLabel?: string | null
}

export function PostCardAuthorMeta({ name, avatarUrl, dateLabel }: PostCardAuthorMetaProps) {
  const displayName = String(name || '').trim() || 'Usuario'
  const fallback = displayName?.[0] || 'U'

  return (
    <div className="flex min-w-0 items-center justify-end gap-2 text-[11px]">
      <div className="min-w-0 flex flex-col items-end leading-tight">
        <span className="max-w-full truncate font-semibold text-foreground">{displayName}</span>
        {dateLabel ? <span className="whitespace-nowrap text-[#454545]">{dateLabel}</span> : null}
      </div>
      <Avatar
        src={avatarUrl || undefined}
        alt={displayName}
        className="h-6 w-6 border-none"
        fallback={fallback}
      />
    </div>
  )
}
